export default "__VITE_ASSET__33e048bf__"